<template>
  <div
    class="bb-popup-info"
    v-click-outside="onClose"
    :style="popupStyle"
  >
    <div class="bb-popup-info__container">
      <div
        v-for="item in data"
        :key="item.id"
        class="bb-popup-info__body"
        :class="{'bb-popup-info__body_text': item.type === 'string'}"
      >

        <span class="bb-popup-info__label">{{item.label}}</span>
        <span v-if="item.type !== 'image'">
          {{item.type === 'date' ? formattedDate : item.value}}
        </span>
        <div
          v-if="item.type === 'image'"
          class="bb-popup-info__image"
        >
          <img v-if="item.value" :src="item.value" alt="icon">
          <div v-else class="bb-popup-info__image-default">
            <i class="icon-user bb-table-body-first-name__avatar bb-table-body-first-name__avatar_icon" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'BBPopupInfoCommunication',
  props: ['data', 'popupStyle'],
  computed: {
    formattedDate () {
      const format = 'DD-MMM-YY';
      const date = this.data.find(item => item.type === 'date');
      return date ? moment(new Date(date.value)).format(format) : '';
    },
  },
  methods: {
    onClose () {
      this.$emit('close')
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

.bb-popup-info {
  padding: 10px;
  background: rgba($color-black, 0.55);
  font-weight: 400;
  line-height: 14px;
  font-size: 12px;
  color: $color-white;
  border-radius: 5px;
  z-index: 20;
  user-select: none;

  &:before {
    content: '';
    position: absolute;
    right: 10px;
    top: -4px;
    display: block;
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 4px solid rgba($color-black, 0.55);
  }

  &__container {
    display: grid;
    grid-gap: 4px 0;
  }

  &__body {
    display: flex;
    align-items: center;
    column-gap: 5px;

    &_text {
      align-items: flex-start;
    }
  }

  &__label {
    font-weight: 500;
  }

  &__close {
    position: absolute;
    right: 2px;
    top: 4px;
    color: $color-silver-new;
    cursor: pointer;
    transition: 0.2s all;
  }

  &__image {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    overflow: hidden;


    img {
      max-width: 100%;
    }
  }

  &__image-default {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $color-white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPopupInfo/BBPopupInfoCommunication.vue